export default {
	craftsmanTasks: {
		create: 'Handwerkerauftrag erstellen',
		createFromReport: 'Aus Meldung erstellen',
		subject_type: 'Art',
		craftsman: 'Handwerker',
		craftsmanTaskType: 'Handwerkerauftrag Art',
		scheduling: 'Terminierung',
		process: 'Vorgang',
		building: {
			name: '@:entity.building.name',
		},
		unit: {
			name: '@:entity.unit.name',
		},
		team: {
			last_name: '@:entity.team.name',
		},
		assignedOn: 'Beauftragt am',
		completed: 'Erledigt',
		estimated_price: 'Schätzbetrag',
		bill_price: 'Rechnungsbetrag',
		status_text: 'Informationen zum aktuellen Status',
		editStatusText: 'Statustext bearbeiten',
		statusTextUpdated: 'Der Statustext wurde aktualisiert.',
		confirmEmptyStatusText:
			'Der Statustext ist leer. Soll der Status wirklich ohne Statustext gespeichert werden?',
		confirmTakeOverStatusText:
			'Soll der bisherige Statustext für den neuen Status übernommen werden?',
		contact_persons: 'Kontaktpersonen',
		record: 'Akte',
		taskUpdated: 'Der Handwerkerauftrag wurde aktualisiert.',
		reopen: 'Wieder öffnen',
		confirmReopen:
			'Soll der Auftrag wirklich wieder geöffnet werden? Er ist danach wieder bearbeitbar.',
		taskReopened: 'Der Handwerkerauftrag wurde wieder geöffnet.',
		confirmDelete:
			'Soll dieser Handwerkerauftrag wirklich gelöscht werden? Damit ist alles dazu weg. Das lässt sich nicht rückgängig machen.',
		taskDeleted: 'Der Handwerkerauftrag wurde gelöscht.',
		invalidPrice:
			'Der Schätzbetrag muss ein gültiger Betrag sein (z. B. 1250,00).',
		detail: {
			taskData: 'Auftragsdaten',
			editModeHint:
				'Bearbeitungsmodus — Änderungen werden erst mit „Speichern“ übernommen.',
			billPricePending: 'liegt noch nicht vor',
			today: 'heute',
			contactPerson: 'Ansprechpartner',
			noCraftsman: 'Kein Handwerker zugeordnet',
			sections: {
				order: 'Auftrag',
				assignment: 'Zuordnung',
				amounts: 'Beträge',
				dates: 'Termine',
			},
		},
		statusTexts: {
			title: 'Statustexte',
			open: 'Alle Statustexte',
			currentStatus: 'Aktueller Status',
			empty: 'Kein Statustext hinterlegt',
			noStatuses: 'Es sind keine Status hinterlegt.',
			explainer:
				'Jeder Status führt seinen eigenen Statustext. Beim Statuswechsel geht nichts verloren — die Texte früherer Status bleiben gespeichert und sind hier jederzeit einsehbar.',
		},
		persons: 'Beteiligte Personen',
		personType: 'Typ',
		personSourceBuilding: 'Liegenschaft',
		personSourceUnit: 'Einheit',
		personSourceAll: 'Alle Personen',
		personsLink: 'Person verknüpfen',
		removePersonLabel: 'Verknüpfung zu {name} entfernen',
		removePersonAction: 'Entfernen',
		personsLinked: 'Verknüpfte Personen',
		personsEmpty: 'Noch keine Personen verknüpft.',
		personsSummary:
			'Keine Person verknüpft | 1 Person verknüpft | {count} Personen verknüpft',
		personPreselected: 'Einzige aktive Person der Einheit vorausgewählt',
		personAlreadyLinked: 'Diese Person ist bereits verknüpft',
		personDuplicate:
			'Die Person ist bereits mit dem Typ „{type}“ verknüpft.',
		personAddedAlsoAs:
			'Die Person wurde verknüpft. Hinweis: Sie war bereits als „{type}“ verknüpft.',
		personAdded: 'Die Person wurde verknüpft.',
		personAddFailed: 'Die Person konnte nicht verknüpft werden.',
		personRemoved: 'Die Personen-Verknüpfung wurde entfernt.',
		confirmRemovePerson:
			'Möchten Sie die Verknüpfung zu {name} wirklich entfernen?',
		noContactData: 'Keine Kontaktdaten hinterlegt',
		uploadDocuments: 'Dokumente hochladen',
		linkDocument: 'Dokument verknüpfen',
		linkDocumentHint:
			'Wählen Sie ein bestehendes Dokument aus. Verknüpft wird der zugehörige Dokumenten-Ordner mit allen enthaltenen Dateien.',
		linkDocumentBuildingSource: 'Dokumente der Liegenschaft laden',
		linkDocumentUnitSource: 'Dokumente der Einheit laden',
		unlinkDocuments: 'Verknüpfung entfernen',
		confirmUnlinkDocuments:
			'Möchten Sie die Verknüpfung der ausgewählten Dokumente wirklich entfernen? Die Dateien bleiben erhalten; entfernt wird jeweils der gesamte zugehörige Dokumenten-Ordner.',
		filterByLinkedPerson: 'Verknüpfte Person',
		documentLinked: 'Das Dokument wurde verknüpft.',
		documentUnlinked: 'Die Dokument-Verknüpfung wurde entfernt.',
		isUpdated: 'wurde aktualisiert',
		total_amount: '@:component.invoice.total_amount',
		activityTab: {
			tabLabel: 'Verlauf',
			empty: 'Für diesen Handwerkerauftrag wurden noch keine Änderungen protokolliert. Sobald jemand Angaben speichert, erscheint hier der Verlauf.',
		},
		directMail: {
			action: 'E-Mail an Beteiligte',
			title: 'E-Mail an Beteiligte',
			to: 'An',
			cc: 'CC',
			bcc: 'BCC',
			template: 'Vorlage',
			templateHint:
				'Wählen Sie eine Vorlage, um Betreff und Text automatisch zu befüllen. Beide Felder bleiben danach frei bearbeitbar.',
			subject: '@:common.subject',
			body: 'Nachricht',
			send: '@:common.send',
			noEmail: 'Keine E-Mail-Adresse hinterlegt',
			freeEmailHint:
				'Weitere E-Mail-Adresse eingeben und mit Enter bestätigen',
			invalidEmail: '„{value}" ist keine gültige E-Mail-Adresse.',
			recipientRequired:
				'Bitte wählen Sie mindestens einen Empfänger im Feld „An" aus.',
			subjectRequired: 'Bitte geben Sie einen Betreff ein.',
			bodyRequired: 'Bitte geben Sie eine Nachricht ein.',
			missingPlaceholders:
				'Für folgende Felder liegen keine Werte vor: {fields}',
			confirmOverwriteTemplate:
				'Beim Wechsel der Vorlage gehen Ihre Änderungen an Betreff und Text verloren. Möchten Sie fortfahren?',
			confirmDiscard:
				'Es gibt ungespeicherte Änderungen. Möchten Sie den Dialog wirklich schließen?',
			emailSent: 'Die E-Mail wurde versendet.',
			sendFailed: 'Die E-Mail konnte nicht versendet werden.',
			previewFailed: 'Die Vorschau konnte nicht geladen werden.',
			contactOf: 'Ansprechpartner von {name}',
			context: {
				taskLabel: 'Auftrag Nr. {number}',
			},
			attachments: {
				show: 'Anhänge hinzufügen',
				hide: 'Anhänge ausblenden',
				title: 'Anhänge',
				none: 'Keine Anhänge',
				upload: 'Dateien auswählen',
				existing: 'Zugeordnete Dokumente anhängen',
				noDocuments: 'Diesem Auftrag sind keine Dokumente zugeordnet.',
				untitledDocument: 'Dokument ohne Bezeichnung',
				totalSize: 'Anhänge gesamt: {size}',
			},
			loadingTemplates: 'Vorlagen werden geladen…',
			loadingPreview: 'Vorschau wird geladen…',
			footer: {
				recipients: 'Empfänger | Empfänger',
				attachments: 'Anhang | Anhänge',
			},
		},
	},
}
